// src/components/NFTDetail/NFTDetailDesign.jsx
import React, { useEffect, useState } from "react";
import "./NFTDetailDesign.css";
import { addComment, getComment, getNftHistory, getNFTTokenDetailAPI } from "../../api/nft/nft";
import { clickWhenReady, errorMessageHandler, fetchNftImage, fetchUserProfileImage, formatTime, getVideoUrl, isVideo, randomAwatarGenerator, SpinnerLoader } from "../../utils/utils";
import { Link, useParams } from "react-router-dom";
import ErrorMessage from "../Layouts/ErrorMessage/ErrorMessage";
import AddAndFetchComment from "./Comment/AddAndFetchComment";
import { useSelector } from "react-redux";
import Details from "./Details/Details";
import History from "./NftHistory/History";
import TransferNft from "./TransferNft/TransferNft";
import SuccessModal from "../Layouts/Modals/SuccessModal";
import OwnerHistory from "./OwnerHistory/OwnerHistory";
import PlaceOrder from "./PlaceOrder/PlaceOrder";
import BuyNft from "./BuyNft/BuyNft";
import CancelOrder from "./CancelOrder/CancelOrder";
import SkeletonLoading from "../Layouts/SkeletonLoading/SkeletonLoading";
import { toast } from 'react-toastify';
import { Button } from "react-bootstrap";
import MissingMnemonics from "../Layouts/MissingMnemonics/MissingMnemonics";
import { useS3Image } from "../../hooks/useS3Image";

const ItemDetail = () => {
  const { id } = useParams();
  const currentUser = useSelector((state) => state.Profile.profile);
  // Placeholder UI-only sample data
  const [nftLoading, setNftLoading] = useState(true)
  const [nftLoadingError, setNftLoadingError] = useState("")
  const [nftDetailObject, setNftDetailObject] = useState({})
  const [successModalTitle, setSuccessModalTitle] = useState("NFT Transferred Successfully!")
  const [successModalMessage, setSuccessModalMessage] = useState("Your NFT has been successfully transferred.")
  const [showTransferNftModal, setShowTransferNftModal] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showPlaceOrderModal, setShowPlaceOrderModal] = useState(false)
  const [showBuyNftModal, setShowBuyNftModal] = useState(false)
  const [showCancelOrderModal, setShowCancelOrderModal] = useState(false)
  const [transferRecipient, setTransferRecipient] = useState(null);
  const [listingInfo, setListingInfo] = useState(null);
  const [cancelInfo, setCancelInfo] = useState(null);
  const [purchaseInfo, setPurchaseInfo] = useState(null);
  const [copiedHash, setCopiedHash] = useState(false);
  const [isOpenOrder, setIsOpenOrder] = useState(false)
  const [isOwner, setIsOwner] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [showFullscreen, setShowFullscreen] = useState(false)
  const [shouldTrigger, setShouldTrigger] = useState(false);
  let fileType = isVideo(nftDetailObject?.resource_type) ? "videos" : "images";
  const { resourceUrl, loading, error } = useS3Image(
    nftDetailObject?.resource_url,
    fileType
  );


  useEffect(() => {
    getNftDetail()
  }, [])

  // Handle ESC key for fullscreen close
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape' && showFullscreen) {
        setShowFullscreen(false);
      }
    };

    if (showFullscreen) {
      document.addEventListener('keydown', handleEscKey);
      // Prevent body scrolling when fullscreen is open
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscKey);
      document.body.style.overflow = 'unset';
    };
  }, [showFullscreen])

  let getNftDetail = async () => {
    try {
      let { data } = await getNFTTokenDetailAPI(id)
      if (data.data.openOrder == null) {
        setIsOpenOrder(false)
      }
      else {
        setIsOpenOrder(true)
      }
      if (currentUser.user_id == data.data.owner_id) {
        setIsOwner(true)
      }
      else {
        setIsOwner(false)
      }

      setNftDetailObject(data.data)
      setNftLoading(false)
    }
    catch (e) {
      console.log("weee", e)
      setNftLoading(false)
      setNftLoadingError(errorMessageHandler(e))

    }
  }

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedHash(true);
      toast.success('Transaction hash copied to clipboard!', {
        position: "bottom-center",
        autoClose: 2000,
      });
      setTimeout(() => setCopiedHash(false), 2000);
    } catch (err) {
      toast.error('Failed to copy', {
        position: "bottom-center",
        autoClose: 2000,
      });
    }
  };
  useEffect(() => {
    const message = localStorage.getItem("showToast");
    if (message) {
      toast.success(message); // or alert(message)
      localStorage.removeItem("showToast");
    }
  }, []);

  return (
    <main>
      <section id="NFTDetailDesign" className="pt-4 pt-lg-5">
        <div className="container-fluid">
          {nftLoadingError && !nftLoading ? (
            // Error State - Beautiful centered error message
            <div className="row justify-content-center">
              <div className="col-12 col-md-8 col-lg-6">
                <div
                  className="d-flex flex-column justify-content-center align-items-center text-center"
                  style={{
                    minHeight: '60vh',
                    padding: '3rem 1.5rem'
                  }}
                >
                  <div
                    className="mb-4"
                    style={{
                      fontSize: '64px',
                      width: '120px',
                      height: '120px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, rgba(220, 53, 69, 0.1) 0%, rgba(220, 53, 69, 0.05) 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      border: '3px solid rgba(220, 53, 69, 0.2)',
                      boxShadow: '0 8px 24px rgba(220, 53, 69, 0.15)'
                    }}
                  >
                    <i className="fas fa-exclamation-triangle text-danger" style={{ fontSize: '48px' }}></i>
                  </div>
                  <h2
                    className="fw-bold mb-3"
                    style={{
                      fontSize: '28px',
                      color: '#dc3545',
                      letterSpacing: '-0.5px'
                    }}
                  >
                    Unable to Load NFT Details
                  </h2>
                  <p
                    className="text-muted mb-4"
                    style={{
                      fontSize: '16px',
                      maxWidth: '500px',
                      lineHeight: '1.6',
                      color: '#6c757d'
                    }}
                  >
                    {nftLoadingError}
                  </p>
                  <button
                    onClick={() => {
                      setNftLoadingError("");
                      setNftLoading(true);
                      getNftDetail();
                    }}
                    className="btn btn-danger px-5 py-3"
                    style={{
                      borderRadius: '12px',
                      fontSize: '16px',
                      fontWeight: '600',
                      boxShadow: '0 4px 12px rgba(220, 53, 69, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)';
                      e.currentTarget.style.boxShadow = '0 6px 16px rgba(220, 53, 69, 0.4)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 12px rgba(220, 53, 69, 0.3)';
                    }}
                  >
                    <i className="fas fa-redo me-2"></i>
                    Try Again
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="row justify-content-center gx-4 gy-4">
              {/* Media column */}
              <div className="col-12 col-lg-6 col-xxl-7 d-flex">
                <div className="NFTDetailDesign__media w-100">
                  {/* Image placeholder; swap with <video> if needed */}
                  {
                    nftLoading ? (
                      <div
                        className="NFTDetailDesign__mediaFrame rounded"
                        style={{
                          placeItems: 'stretch'
                        }}
                      >
                        <SkeletonLoading
                          className="w-100 h-100 rounded"
                          style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '0.375rem',
                            display: 'block'
                          }}
                        />
                      </div>
                    ) : (
                      <div className="NFTDetailDesign__mediaFrame rounded position-relative">
                        {/* Premium decorative background elements */}
                        <div className="NFTDetailDesign__mediaBackdrop"></div>

                        {/* Main media container with premium styling */}
                        <div className="NFTDetailDesign__mediaContent">
                          {isVideo(nftDetailObject?.resource_type) ? (
                            <div className="NFTDetailDesign__videoWrapper">
                              <video
                                className="NFTDetailDesign__video"
                                autoPlay
                                loop
                                muted
                                playsInline
                                controls
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                  borderRadius: '16px'
                                }}
                              >
                                <source src={resourceUrl} type={`video/${nftDetailObject.resource_type}`} />
                                <source src={resourceUrl} type="video/mp4" />
                                <source src={resourceUrl} type="video/mov" />
                                <source src={resourceUrl} type="video/webm" />
                                Your browser does not support the video tag.
                              </video>

                              {/* Enhanced Video badge indicator */}
                              <div className="NFTDetailDesign__mediaBadge NFTDetailDesign__videoBadge">
                                <div className="NFTDetailDesign__badgeIcon">
                                  <i className="fas fa-play"></i>
                                </div>
                                <span>Video</span>
                              </div>
                            </div>
                          ) : (
                            <div className="NFTDetailDesign__imageWrapper">
                              <img
                                className="NFTDetailDesign__image"
                                src={resourceUrl}
                                alt={nftDetailObject?.title || "NFT"}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'contain',
                                  borderRadius: '16px'
                                }}
                              />
                            </div>
                          )}
                        </div>

                        {/* Premium shine effect overlay */}
                        <div className="NFTDetailDesign__shineOverlay"></div>

                        {/* Fullscreen/Expand button */}
                        <button
                          className="NFTDetailDesign__expandButton"
                          onClick={() => setShowFullscreen(true)}
                          title="View Fullscreen"
                          aria-label="View Fullscreen"
                        >
                          <i className="fas fa-expand-alt"></i>
                        </button>
                      </div>
                    )
                  }

                  {/* Mobile title + price */}
                  <div className="d-lg-none mt-3">
                    <h2 className="HeadingEllipsis mb-2">
                      {nftLoading ? (
                        <SkeletonLoading style={{ width: '70%', height: '1.5rem' }} />
                      ) : (
                        nftDetailObject?.title
                      )}
                    </h2>
                    <div className="d-flex align-items-center justify-content-between">
                      <p className="mb-0">
                        <span className="text-secondary">Price</span>{" "}
                        <span className="color-red fw-bold">{nftLoading ? "Loading..." : nftDetailObject?.price}</span>
                      </p>
                      <span className="badge bg-dark-subtle text-dark">Fixed Price</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Info column */}
              <div className="col-12 col-lg-6 col-xxl-5">
                <div className="NFTDetailDesign__panel d-flex flex-column h-100">
                  {/* Title + actions */}
                  <div className="d-none d-lg-flex align-items-start justify-content-between mb-2">
                    <h2 className="HeadingEllipsis me-3 mb-0">{nftLoading ? <SkeletonLoading style={{ width: '60%', height: '1.8rem' }} /> : nftDetailObject?.title}</h2>

                    <button className="btn btn-outline-secondary btn-sm px-3">
                      •••
                    </button>
                  </div>

                  {/* Price + quick facts */}
                  <div className="NFTDetailDesign__priceCard rounded p-3 mb-3">
                    <div className="row align-items-center">
                      <div className="col-sm-6 mb-2 mb-sm-0">
                        <div className="text-secondary">Price</div>
                        <div className="fs-4 fw-bold color-red">{nftLoading ? <SkeletonLoading style={{ width: '40%', height: '1.5rem' }} /> : nftDetailObject?.price + " " + "NUC"} </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="d-flex gap-3 small text-secondary justify-content-sm-end">
                          <div className="text-nowrap">
                            <span className="text-dark fw-semibold">Token ID:</span> {nftLoading ? "Loading..." : nftDetailObject?.blockchain_token_id}
                          </div>
                          {/* <div className="text-nowrap">
                          <span className="text-dark fw-semibold">Supply:</span> 1 of 1
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Owner + Creator */}
                  <div className="row g-3 mb-3">

                    <div className="col-6">
                      <Link to={`/profile/${nftDetailObject?.creator_details?.user_name}`} >
                        <label className="form-label CeraBold d-block mb-1">Creator</label>

                        <div className="d-flex align-items-center">
                          <div className="rounded-circle NFTDetailDesign__avatar me-2">
                            {
                              <img
                                src={fetchUserProfileImage(nftDetailObject?.creator_details?.profile_image)}
                                alt={nftDetailObject?.creator_details?.user_name}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  borderRadius: '50%'
                                }}
                              />
                            }

                          </div>

                          <div className={nftLoading ? "" : "text-truncate"}>
                            {nftLoading ? (
                              <SkeletonLoading style={{ width: '100px', height: '1.5rem', display: 'block' }} />
                            ) : (
                              nftDetailObject?.creator_details?.first_name
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>


                    <div className="col-6">
                      <Link to={`/profile/${nftDetailObject?.current_owner_details?.user_name}`} >
                        <label className="form-label CeraBold d-block mb-1">
                          {!nftLoading && isOpenOrder ? 'Owned & Listed By' : 'Current Owner'}
                        </label>
                        <div className="d-flex align-items-center">
                          <div className="rounded-circle NFTDetailDesign__avatar me-2">
                            {
                              <img
                                src={fetchUserProfileImage(nftDetailObject?.current_owner_details?.profile_image)}
                                alt={nftDetailObject?.current_owner_details?.user_name}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  objectFit: 'cover',
                                  borderRadius: '50%'
                                }}
                              />
                            }

                          </div>
                          <div className={nftLoading ? "" : "text-truncate"}>
                            {nftLoading ? (
                              <SkeletonLoading style={{ width: '100px', height: '1.5rem', display: 'block' }} />
                            ) : (
                              nftDetailObject?.current_owner_details?.first_name
                            )}
                          </div>
                        </div>
                      </Link>
                    </div>

                  </div>

                  {/* Actions */}
                  <div className="row g-2 mb-3">
                    {
                      /* Show only Purchase button for non-owners viewing open order */
                      !nftLoading && isOpenOrder && nftDetailObject.current_owner != currentUser.user_id &&
                      <div className="col-12">
                        <button onClick={() => { setShowBuyNftModal(true); }} className="btn BtnBlack w-100 py-2 d-flex align-items-center justify-content-center">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-bag-check me-2" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M10.854 8.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                            <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1zm3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4h-3.5zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5z" />
                          </svg>
                          <span>Purchase NFT</span>
                        </button>
                      </div>
                    }

                    {
                      /* Show Cancel and Transfer buttons for owners with open order */
                      !nftLoading && isOpenOrder && nftDetailObject.current_owner == currentUser.user_id &&
                      <>
                        <div className="col-12 col-sm-6">
                          <button onClick={() => { setShowCancelOrderModal(true); }} className="btn BtnBlack w-100 py-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle me-2" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                            </svg>
                            Cancel Listing
                          </button>
                        </div>
                        <div className="col-12 col-sm-6">
                          <button
                            className="btn btn-outline-dark w-100 py-2"
                            onClick={() => { setShowTransferNftModal(true); }}
                            disabled={true}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right me-2" viewBox="0 0 16 16">
                              <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z" />
                            </svg>
                            Transfer Ownership
                          </button>
                        </div>
                      </>
                    }

                    {
                      /* Show List and Transfer buttons for owners without open order */
                      !isOpenOrder && nftLoading === false && nftDetailObject.current_owner == currentUser.user_id &&
                      <>
                        <div className="col-12 col-sm-6">
                          <button onClick={() => { setShowPlaceOrderModal(true); }} className="btn BtnBlack w-100 py-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tag me-2" viewBox="0 0 16 16">
                              <path d="M6 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm-1 0a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0z" />
                              <path d="M2 1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 1 6.586V2a1 1 0 0 1 1-1zm0 5.586 7 7L13.586 9l-7-7H2v4.586z" />
                            </svg>
                            List for Sale
                          </button>
                        </div>
                        <div className="col-12 col-sm-6">
                          <button
                            className="btn btn-outline-dark w-100 py-2"
                            onClick={() => { setShowTransferNftModal(true); }}
                            disabled={false}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-right me-2" viewBox="0 0 16 16">
                              <path fillRule="evenodd" d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z" />
                            </svg>
                            Transfer Ownership
                          </button>
                        </div>
                      </>
                    }
                  </div>

                  {
                    !nftLoading && isOpenOrder && nftDetailObject.current_owner == currentUser.user_id && (
                      <div className="bg-light border border-primary rounded p-3 mb-3" style={{ borderLeft: '4px solid #0d6efd' }}>
                        <div className="d-flex align-items-start">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#0d6efd" className="me-2 flex-shrink-0 mt-1" viewBox="0 0 16 16">
                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                          </svg>
                          <div>
                            <div className="fw-semibold mb-1 text-primary">Transfer Restricted</div>
                            <small className="text-muted">To transfer this NFT, please cancel the active order first. Once the order is cancelled, you'll be able to transfer ownership.</small>
                          </div>
                        </div>
                      </div>
                    )
                  }

                  {
                    !nftLoading && isOpenOrder && nftDetailObject?.openOrder && (
                      <div className="rounded mb-3" style={{
                        background: 'linear-gradient(135deg, rgba(25, 135, 84, 0.05) 0%, rgba(25, 135, 84, 0.02) 100%)',
                        border: '1px solid rgba(25, 135, 84, 0.2)',
                        overflow: 'hidden'
                      }}>
                        {/* Header */}
                        <div className="d-flex align-items-center justify-content-between p-3 pb-2" style={{
                          borderBottom: '1px solid rgba(25, 135, 84, 0.15)'
                        }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{
                              width: '32px',
                              height: '32px',
                              background: 'linear-gradient(135deg, #198754 0%, #20c997 100%)',
                              borderRadius: '8px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              boxShadow: '0 2px 8px rgba(25, 135, 84, 0.25)'
                            }}>
                              <i className="fas fa-check-circle" style={{ color: '#fff', fontSize: '14px' }}></i>
                            </div>
                            <h6 className="mb-0 fw-bold" style={{ color: '#198754', letterSpacing: '-0.3px' }}>Active Order</h6>
                          </div>
                          <span className="badge" style={{
                            background: '#198754',
                            color: '#fff',
                            padding: '4px 10px',
                            borderRadius: '6px',
                            fontSize: '0.7rem',
                            fontWeight: '600',
                            letterSpacing: '0.5px'
                          }}>
                            {nftDetailObject.openOrder.status.toUpperCase()}
                          </span>
                        </div>

                        {/* Content */}
                        <div className="px-3 pb-3 pt-2">
                          {/* Listed On & Order ID */}
                          <div className="row g-3 mb-3 pb-3" style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.06)' }}>
                            <div className="col-6">
                              <div className="d-flex align-items-center gap-1 mb-1">
                                <i className="far fa-clock" style={{ fontSize: '11px', color: '#8b949e' }}></i>
                                <span style={{ fontSize: '0.7rem', color: '#8b949e', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Listed On</span>
                              </div>
                              <div style={{ fontSize: '0.8rem', fontWeight: '600', color: '#1f2937', lineHeight: '1.5' }}>
                                {formatTime(nftDetailObject.openOrder.timestamps?.created_At)}
                              </div>
                            </div>
                            <div className="col-6">
                              <div className="d-flex align-items-center gap-1 mb-1">
                                <i className="fas fa-hashtag" style={{ fontSize: '10px', color: '#8b949e' }}></i>
                                <span style={{ fontSize: '0.7rem', color: '#8b949e', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Order ID</span>
                              </div>
                              <div style={{ fontSize: '0.8rem', fontWeight: '600', color: '#1f2937', lineHeight: '1.5' }}>
                                {nftDetailObject.openOrder.blockchain_order_id}
                              </div>
                            </div>
                          </div>

                          {/* Order Hash */}
                          <div>
                            <div className="d-flex align-items-center gap-1 mb-2">
                              <i className="fas fa-link" style={{ fontSize: '10px', color: '#8b949e' }}></i>
                              <span style={{ fontSize: '0.7rem', color: '#8b949e', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Order Hash</span>
                            </div>
                            <div className="d-flex align-items-center gap-2 p-2 rounded" style={{ background: 'rgba(0, 0, 0, 0.03)', border: '1px solid rgba(0, 0, 0, 0.06)' }}>
                              <a
                                href={`${process.env.REACT_APP_NFT_EXPLORER}/${nftDetailObject.openOrder.orderHash}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-monospace flex-grow-1"
                                style={{
                                  fontSize: '0.7rem',
                                  wordBreak: 'break-all',
                                  color: '#4b5563',
                                  textDecoration: 'none',
                                  cursor: 'pointer',
                                  fontWeight: '500',
                                  lineHeight: '1.5',
                                  transition: 'color 0.2s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.color = '#1f2937';
                                  e.currentTarget.style.textDecoration = 'underline';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.color = '#4b5563';
                                  e.currentTarget.style.textDecoration = 'none';
                                }}
                              >
                                {nftDetailObject.openOrder.orderHash}
                              </a>
                              <button
                                onClick={() => copyToClipboard(nftDetailObject.openOrder.orderHash)}
                                className="btn btn-sm"
                                style={{
                                  padding: '5px 10px',
                                  border: '1px solid #e5e7eb',
                                  background: copiedHash ? 'linear-gradient(135deg, #198754 0%, #20c997 100%)' : '#fff',
                                  color: copiedHash ? '#fff' : '#6b7280',
                                  borderRadius: '6px',
                                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                  fontSize: '0.7rem',
                                  boxShadow: copiedHash ? '0 2px 6px rgba(25, 135, 84, 0.3)' : '0 1px 2px rgba(0, 0, 0, 0.05)',
                                  transform: copiedHash ? 'scale(1.05)' : 'scale(1)'
                                }}
                                onMouseEnter={(e) => {
                                  if (!copiedHash) {
                                    e.currentTarget.style.background = '#f9fafb';
                                    e.currentTarget.style.borderColor = '#d1d5db';
                                    e.currentTarget.style.transform = 'translateY(-1px)';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.08)';
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  if (!copiedHash) {
                                    e.currentTarget.style.background = '#fff';
                                    e.currentTarget.style.borderColor = '#e5e7eb';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 1px 2px rgba(0, 0, 0, 0.05)';
                                  }
                                }}
                                title={copiedHash ? 'Copied!' : 'Copy'}
                              >
                                <i className={`fas ${copiedHash ? 'fa-check' : 'fa-copy'}`}></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }


                  {/* Tabs */}
                  <ul className="nav nav-tabs BorderBottom mb-3" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="comments-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#comments"
                        type="button"
                        role="tab"
                        aria-controls="comments"
                        aria-selected="false"
                      >
                        Comments
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="owners-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#owners"
                        type="button"
                        role="tab"
                        aria-controls="owners"
                        aria-selected="false"
                      >
                        Owners History
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="activity-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#activity"
                        type="button"
                        role="tab"
                        aria-controls="activity"
                        aria-selected="false"
                      >
                        Activity
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="details-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#details"
                        type="button"
                        role="tab"
                        aria-controls="details"
                        aria-selected="true"
                      >
                        Details
                      </button>
                    </li>
                  </ul>



                  <div className="tab-content">
                    {/* Details */}
                    <Details refresh={refresh} nftLoading={nftLoading} nftLoadingError={nftLoadingError} nftDetailObject={nftDetailObject}></Details>
                    {/* Comments */}
                    <AddAndFetchComment refresh={refresh} id={id} currentUser={currentUser} />
                    {/* Owners History */}
                    <OwnerHistory refresh={refresh} id={id}></OwnerHistory>
                    {/* Activity */}
                    <History refresh={refresh} id={id}></History>

                  </div>

                  {/* Bottom helper line for spacing on large screens */}
                  <div className="mt-auto d-none d-lg-block"></div>
                </div>
              </div>
            </div>
          )}
        </div>


        {/* //Modal */}

        {
          isOpenOrder &&

          <CancelOrder isOpen={showCancelOrderModal}
            onClose={() => { setShowCancelOrderModal(false) }}
            onSuccess={(hash) => {
              setCancelInfo({ hash });
              setShowSuccessModal(true);
              setSuccessModalTitle("Listing Cancelled Successfully!");
              setSuccessModalMessage(`Your NFT listing has been removed from the marketplace. The NFT is still in your collection and you can list it for sale again anytime.`)
            }}
            id={id}
            nftDetailObject={nftDetailObject}
          />
        }


        {
          isOpenOrder &&

          <BuyNft isOpen={showBuyNftModal}
            onClose={(value) => {
              setShowBuyNftModal(false)
              if (value === true) {
                setShouldTrigger(true)
              }
            }}
            onSuccess={(price, hash) => {
              setPurchaseInfo({ hash, price })
              setShowSuccessModal(true);
              setSuccessModalTitle("NFT Purchased Successfully!");
              setSuccessModalMessage(`Congratulations! You have successfully purchased this NFT for ${price} NUC. The NFT is now in your collection.`)
            }}
            id={id}
            nftDetailObject={nftDetailObject}
          />
        }
        {/* <button onClick={press}>Check Wallet modal</button> */}
        {
          !isOpenOrder &&
          <PlaceOrder isOpen={showPlaceOrderModal}
            onClose={() => { setShowPlaceOrderModal(false) }}
            onSuccess={(price, hash) => {
              setListingInfo({ price, hash });
              setShowSuccessModal(true);
              setSuccessModalTitle("NFT Listed for Sale!");
              setSuccessModalMessage(`Your NFT has been successfully listed for sale at the new price ${price} NUC. It is now available for purchase on the marketplace.`)
            }}
            id={id} />
        }


        {/* Transfer modal */}
        {!isOpenOrder &&
          <TransferNft
            isOpen={showTransferNftModal}
            onClose={(result) => {
              if (result?.success && result?.recipientInfo) {
                setTransferRecipient(result.recipientInfo);
                setShowSuccessModal(true);
              }
              setShowTransferNftModal(false);
            }}
            id={id}
          ></TransferNft>
        }

      </section>

      {/* Fullscreen Media Viewer */}
      {showFullscreen && (
        <div
          className="NFTDetailDesign__fullscreenOverlay"
          onClick={() => setShowFullscreen(false)}
        >
          <div className="NFTDetailDesign__fullscreenContent" onClick={(e) => e.stopPropagation()}>
            {/* Close button */}
            <button
              className="NFTDetailDesign__fullscreenClose"
              onClick={() => setShowFullscreen(false)}
              title="Close Fullscreen"
              aria-label="Close Fullscreen"
            >
              <i className="fas fa-times"></i>
            </button>

            {/* Media display */}
            <div className="NFTDetailDesign__fullscreenMedia">
              {isVideo(nftDetailObject?.resource_type) ? (
                <video
                  autoPlay
                  loop
                  controls
                  playsInline
                  style={{
                    maxWidth: '100%',
                    maxHeight: '90vh',
                    borderRadius: '12px',
                    boxShadow: '0 20px 80px rgba(0, 0, 0, 0.5)'
                  }}
                >
                  <source src={getVideoUrl(nftDetailObject?.resource_url)} type={`video/${nftDetailObject.resource_type}`} />
                  <source src={getVideoUrl(nftDetailObject?.resource_url)} type="video/mp4" />
                  <source src={getVideoUrl(nftDetailObject?.resource_url)} type="video/mov" />
                  <source src={getVideoUrl(nftDetailObject?.resource_url)} type="video/webm" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <img
                  src={fetchNftImage(nftDetailObject?.resource_url)}
                  alt={nftDetailObject?.title || "NFT"}
                  style={{
                    maxWidth: '95%',
                    maxHeight: '90vh',
                    borderRadius: '12px',
                    boxShadow: '0 20px 80px rgba(0, 0, 0, 0.5)'
                  }}
                />
              )}
            </div>

            {/* Info bar */}
            <div className="NFTDetailDesign__fullscreenInfo">
              <div>
                <h5 className="mb-1 fw-bold">{nftDetailObject?.title}</h5>
                <small className="text-white-50">
                  <i className="fas fa-user me-1"></i>
                  {nftDetailObject?.creator_details?.first_name}
                </small>
              </div>
              <div className="text-end">
                <div className="text-white-50 small mb-1">Price</div>
                <div className="fw-bold fs-5">{nftDetailObject?.price} NUC</div>
              </div>
            </div>
          </div>
        </div>
      )}

      <SuccessModal
        show={showSuccessModal}
        onClose={() => {
          setShowSuccessModal(false);
          setTransferRecipient(null);
          setListingInfo(null);
          setCancelInfo(null)
          setPurchaseInfo(null)
          setNftLoading(true)
          setRefresh(!refresh)
          // Optionally refresh NFT details
          getNftDetail();
        }}
        title={successModalTitle}
        subtitle={transferRecipient ? `Sent to @${transferRecipient.username}` : null}
        message={
          transferRecipient ? (
            <div>
              <p className="mb-3">Your NFT has been successfully transferred to:</p>

              {/* Recipient Info */}
              <div className="transfer-success-recipient mb-3">
                <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                  <i className="fas fa-user-check text-success"></i>
                  <strong style={{ fontSize: '1.1rem' }}>@{transferRecipient.username}</strong>
                </div>
                <div className="transfer-success-address">
                  <small className="text-muted d-block" style={{ wordBreak: 'break-all' }}>
                    {transferRecipient.publicAddress}
                  </small>
                </div>
              </div>

              {/* Transaction Hash */}
              {transferRecipient.hash && (
                <div className="transfer-success-transaction mt-4" style={{
                  background: 'linear-gradient(135deg, rgba(85, 64, 199, 0.08) 0%, rgba(85, 64, 199, 0.15) 100%)',
                  borderRadius: '16px',
                  border: '2px solid rgba(85, 64, 199, 0.25)',
                  padding: '20px',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(85, 64, 199, 0.1)',
                  transition: 'all 0.3s ease'
                }}>
                  {/* Decorative Background Element */}
                  <div style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '-20px',
                    width: '100px',
                    height: '100px',
                    background: 'radial-gradient(circle, rgba(85, 64, 199, 0.15) 0%, rgba(85, 64, 199, 0) 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none'
                  }}></div>

                  {/* Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{
                        width: '36px',
                        height: '36px',
                        background: 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 8px rgba(85, 64, 199, 0.3)'
                      }}>
                        <i className="fas fa-cube" style={{ color: '#fff', fontSize: '1.1rem' }}></i>
                      </div>
                      <div>
                        <strong className="d-block" style={{ fontSize: '1rem', color: '#000' }}>
                          Transaction Hash
                        </strong>
                        <small style={{ color: '#6c757d', fontSize: '0.8rem' }}>
                          <i className="fas fa-check-circle me-1" style={{ color: '#0e9e6d' }}></i>
                          Confirmed on blockchain
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Hash Display */}
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.7)',
                    borderRadius: '12px',
                    padding: '14px 16px',
                    marginBottom: '12px',
                    border: '1px solid rgba(85, 64, 199, 0.15)'
                  }}>
                    <code style={{
                      fontFamily: 'Courier New, monospace',
                      fontSize: '0.85rem',
                      color: '#495057',
                      wordBreak: 'break-all',
                      display: 'block',
                      lineHeight: '1.6'
                    }}>
                      {transferRecipient.hash}
                    </code>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex gap-2">
                    <button
                      onClick={() => copyToClipboard(transferRecipient.hash)}
                      className="btn btn-sm"
                      style={{
                        flex: 1,
                        background: copiedHash ? 'linear-gradient(135deg, #0e9e6d 0%, #0c8a5e 100%)' : 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        boxShadow: copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        if (!copiedHash) {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)';
                      }}
                    >
                      <i className={`fas ${copiedHash ? 'fa-check' : 'fa-copy'}`}></i>
                      {copiedHash ? 'Copied!' : 'Copy Hash'}
                    </button>

                    <a
                      href={`${process.env.REACT_APP_NFT_EXPLORER}/${transferRecipient.hash}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm"
                      style={{
                        flex: 1,
                        background: '#fff',
                        color: '#5540c7',
                        border: '2px solid #5540c7',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        textDecoration: 'none',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#5540c7';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#fff';
                        e.currentTarget.style.color = '#5540c7';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fas fa-external-link-alt"></i>
                      View Explorer
                    </a>
                  </div>
                </div>
              )}
            </div>
          ) : listingInfo ? (
            <div>
              <p className="mb-3">{successModalMessage}</p>

              {/* Listing Price Info */}
              <div className="transfer-success-recipient mb-3">
                <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                  <i className="fas fa-tag text-success"></i>
                  <strong style={{ fontSize: '1.1rem' }}>Listing Price: {listingInfo.price} NUC</strong>
                </div>
              </div>

              {/* Transaction Hash */}
              {listingInfo.hash && (
                <div className="transfer-success-transaction mt-4" style={{
                  background: 'linear-gradient(135deg, rgba(85, 64, 199, 0.08) 0%, rgba(85, 64, 199, 0.15) 100%)',
                  borderRadius: '16px',
                  border: '2px solid rgba(85, 64, 199, 0.25)',
                  padding: '20px',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(85, 64, 199, 0.1)',
                  transition: 'all 0.3s ease'
                }}>
                  {/* Decorative Background Element */}
                  <div style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '-20px',
                    width: '100px',
                    height: '100px',
                    background: 'radial-gradient(circle, rgba(85, 64, 199, 0.15) 0%, rgba(85, 64, 199, 0) 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none'
                  }}></div>

                  {/* Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{
                        width: '36px',
                        height: '36px',
                        background: 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 8px rgba(85, 64, 199, 0.3)'
                      }}>
                        <i className="fas fa-cube" style={{ color: '#fff', fontSize: '1.1rem' }}></i>
                      </div>
                      <div>
                        <strong className="d-block" style={{ fontSize: '1rem', color: '#000' }}>
                          Transaction Hash
                        </strong>
                        <small style={{ color: '#6c757d', fontSize: '0.8rem' }}>
                          <i className="fas fa-check-circle me-1" style={{ color: '#0e9e6d' }}></i>
                          Confirmed on blockchain
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Hash Display */}
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.7)',
                    borderRadius: '12px',
                    padding: '14px 16px',
                    marginBottom: '12px',
                    border: '1px solid rgba(85, 64, 199, 0.15)'
                  }}>
                    <code style={{
                      fontFamily: 'Courier New, monospace',
                      fontSize: '0.85rem',
                      color: '#495057',
                      wordBreak: 'break-all',
                      display: 'block',
                      lineHeight: '1.6'
                    }}>
                      {listingInfo.hash}
                    </code>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex gap-2">
                    <button
                      onClick={() => copyToClipboard(listingInfo.hash)}
                      className="btn btn-sm"
                      style={{
                        flex: 1,
                        background: copiedHash ? 'linear-gradient(135deg, #0e9e6d 0%, #0c8a5e 100%)' : 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        boxShadow: copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        if (!copiedHash) {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)';
                      }}
                    >
                      <i className={`fas ${copiedHash ? 'fa-check' : 'fa-copy'}`}></i>
                      {copiedHash ? 'Copied!' : 'Copy Hash'}
                    </button>

                    <a
                      href={`${process.env.REACT_APP_NFT_EXPLORER}/${listingInfo.hash}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm"
                      style={{
                        flex: 1,
                        background: '#fff',
                        color: '#5540c7',
                        border: '2px solid #5540c7',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        textDecoration: 'none',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#5540c7';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#fff';
                        e.currentTarget.style.color = '#5540c7';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fas fa-external-link-alt"></i>
                      View Explorer
                    </a>
                  </div>
                </div>
              )}
            </div>
          ) : cancelInfo ? (
            <div>
              <p className="mb-3">{successModalMessage}</p>

              {/* Listing Price Info */}


              {/* Transaction Hash */}
              {cancelInfo.hash && (
                <div className="transfer-success-transaction mt-4" style={{
                  background: 'linear-gradient(135deg, rgba(85, 64, 199, 0.08) 0%, rgba(85, 64, 199, 0.15) 100%)',
                  borderRadius: '16px',
                  border: '2px solid rgba(85, 64, 199, 0.25)',
                  padding: '20px',
                  position: 'relative',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(85, 64, 199, 0.1)',
                  transition: 'all 0.3s ease'
                }}>
                  {/* Decorative Background Element */}
                  <div style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '-20px',
                    width: '100px',
                    height: '100px',
                    background: 'radial-gradient(circle, rgba(85, 64, 199, 0.15) 0%, rgba(85, 64, 199, 0) 70%)',
                    borderRadius: '50%',
                    pointerEvents: 'none'
                  }}></div>

                  {/* Header */}
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <div style={{
                        width: '36px',
                        height: '36px',
                        background: 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 8px rgba(85, 64, 199, 0.3)'
                      }}>
                        <i className="fas fa-cube" style={{ color: '#fff', fontSize: '1.1rem' }}></i>
                      </div>
                      <div>
                        <strong className="d-block" style={{ fontSize: '1rem', color: '#000' }}>
                          Transaction Hash
                        </strong>
                        <small style={{ color: '#6c757d', fontSize: '0.8rem' }}>
                          <i className="fas fa-check-circle me-1" style={{ color: '#0e9e6d' }}></i>
                          Confirmed on blockchain
                        </small>
                      </div>
                    </div>
                  </div>

                  {/* Hash Display */}
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.7)',
                    borderRadius: '12px',
                    padding: '14px 16px',
                    marginBottom: '12px',
                    border: '1px solid rgba(85, 64, 199, 0.15)'
                  }}>
                    <code style={{
                      fontFamily: 'Courier New, monospace',
                      fontSize: '0.85rem',
                      color: '#495057',
                      wordBreak: 'break-all',
                      display: 'block',
                      lineHeight: '1.6'
                    }}>
                      {cancelInfo.hash}
                    </code>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex gap-2">
                    <button
                      onClick={() => copyToClipboard(cancelInfo.hash)}
                      className="btn btn-sm"
                      style={{
                        flex: 1,
                        background: copiedHash ? 'linear-gradient(135deg, #0e9e6d 0%, #0c8a5e 100%)' : 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        boxShadow: copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)'
                      }}
                      onMouseEnter={(e) => {
                        if (!copiedHash) {
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.4)';
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)';
                      }}
                    >
                      <i className={`fas ${copiedHash ? 'fa-check' : 'fa-copy'}`}></i>
                      {copiedHash ? 'Copied!' : 'Copy Hash'}
                    </button>

                    <a
                      href={`${process.env.REACT_APP_NFT_EXPLORER}/${cancelInfo.hash}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-sm"
                      style={{
                        flex: 1,
                        background: '#fff',
                        color: '#5540c7',
                        border: '2px solid #5540c7',
                        borderRadius: '10px',
                        padding: '10px 16px',
                        fontWeight: '600',
                        fontSize: '0.85rem',
                        textDecoration: 'none',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#5540c7';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#fff';
                        e.currentTarget.style.color = '#5540c7';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <i className="fas fa-external-link-alt"></i>
                      View Explorer
                    </a>
                  </div>
                </div>
              )}
            </div>
          )
            : purchaseInfo ? (
              <div>
                <p className="mb-3">{successModalMessage}</p>

                {/* Listing Price Info */}
                <div className="transfer-success-recipient mb-3">
                  <div className="d-flex align-items-center justify-content-center gap-2 mb-2">
                    <i className="fas fa-tag text-success"></i>
                    <strong style={{ fontSize: '1.1rem' }}>Buying Price: {purchaseInfo.price} NUC</strong>
                  </div>
                </div>

                {/* Transaction Hash */}
                {purchaseInfo.hash && (
                  <div className="transfer-success-transaction mt-4" style={{
                    background: 'linear-gradient(135deg, rgba(85, 64, 199, 0.08) 0%, rgba(85, 64, 199, 0.15) 100%)',
                    borderRadius: '16px',
                    border: '2px solid rgba(85, 64, 199, 0.25)',
                    padding: '20px',
                    position: 'relative',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(85, 64, 199, 0.1)',
                    transition: 'all 0.3s ease'
                  }}>
                    {/* Decorative Background Element */}
                    <div style={{
                      position: 'absolute',
                      top: '-20px',
                      right: '-20px',
                      width: '100px',
                      height: '100px',
                      background: 'radial-gradient(circle, rgba(85, 64, 199, 0.15) 0%, rgba(85, 64, 199, 0) 70%)',
                      borderRadius: '50%',
                      pointerEvents: 'none'
                    }}></div>

                    {/* Header */}
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center gap-2">
                        <div style={{
                          width: '36px',
                          height: '36px',
                          background: 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          boxShadow: '0 4px 8px rgba(85, 64, 199, 0.3)'
                        }}>
                          <i className="fas fa-cube" style={{ color: '#fff', fontSize: '1.1rem' }}></i>
                        </div>
                        <div>
                          <strong className="d-block" style={{ fontSize: '1rem', color: '#000' }}>
                            Transaction Hash
                          </strong>
                          <small style={{ color: '#6c757d', fontSize: '0.8rem' }}>
                            <i className="fas fa-check-circle me-1" style={{ color: '#0e9e6d' }}></i>
                            Confirmed on blockchain
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* Hash Display */}
                    <div style={{
                      background: 'rgba(255, 255, 255, 0.7)',
                      borderRadius: '12px',
                      padding: '14px 16px',
                      marginBottom: '12px',
                      border: '1px solid rgba(85, 64, 199, 0.15)'
                    }}>
                      <code style={{
                        fontFamily: 'Courier New, monospace',
                        fontSize: '0.85rem',
                        color: '#495057',
                        wordBreak: 'break-all',
                        display: 'block',
                        lineHeight: '1.6'
                      }}>
                        {purchaseInfo.hash}
                      </code>
                    </div>

                    {/* Action Buttons */}
                    <div className="d-flex gap-2">
                      <button
                        onClick={() => copyToClipboard(purchaseInfo.hash)}
                        className="btn btn-sm"
                        style={{
                          flex: 1,
                          background: copiedHash ? 'linear-gradient(135deg, #0e9e6d 0%, #0c8a5e 100%)' : 'linear-gradient(135deg, #5540c7 0%, #7860d9 100%)',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '10px',
                          padding: '10px 16px',
                          fontWeight: '600',
                          fontSize: '0.85rem',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px',
                          boxShadow: copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)'
                        }}
                        onMouseEnter={(e) => {
                          if (!copiedHash) {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.4)';
                          }
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = copiedHash ? '0 4px 12px rgba(14, 158, 109, 0.3)' : '0 4px 12px rgba(85, 64, 199, 0.3)';
                        }}
                      >
                        <i className={`fas ${copiedHash ? 'fa-check' : 'fa-copy'}`}></i>
                        {copiedHash ? 'Copied!' : 'Copy Hash'}
                      </button>

                      <a
                        href={`${process.env.REACT_APP_NFT_EXPLORER}/${purchaseInfo.hash}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm"
                        style={{
                          flex: 1,
                          background: '#fff',
                          color: '#5540c7',
                          border: '2px solid #5540c7',
                          borderRadius: '10px',
                          padding: '10px 16px',
                          fontWeight: '600',
                          fontSize: '0.85rem',
                          textDecoration: 'none',
                          transition: 'all 0.3s ease',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = '#5540c7';
                          e.currentTarget.style.color = '#fff';
                          e.currentTarget.style.transform = 'translateY(-2px)';
                          e.currentTarget.style.boxShadow = '0 6px 16px rgba(85, 64, 199, 0.3)';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = '#fff';
                          e.currentTarget.style.color = '#5540c7';
                          e.currentTarget.style.transform = 'translateY(0)';
                          e.currentTarget.style.boxShadow = 'none';
                        }}
                      >
                        <i className="fas fa-external-link-alt"></i>
                        View Explorer
                      </a>
                    </div>
                  </div>
                )}
              </div>

            ) :
              (
                successModalMessage
              )
        }
        buttonText="Great!"
        icon="fas fa-paper-plane"
      ></SuccessModal>
      <MissingMnemonics visible={shouldTrigger} onClose={() => setShouldTrigger(false)} />
    </main>
  );
};

export default ItemDetail;